export class StringUtils {
	public static padLeft(n: number, length:number): string {
		let zeros = "0".repeat(length);
		if (typeof n === "undefined") {
			return zeros;
		}
		return (zeros + n.toString()).slice(-length);
	}
}